import React from 'react';
import { twMerge } from 'tailwind-merge';

const Row = ({ children, className }) => (
  <td className={twMerge('px-1 sm:px-2 text-xs md:text-sm whitespace-normal break-words', className)}>{children}</td>
);

export default Row;
